import { ReactNode, useId, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export type AccordionItem = {
  question: string;
  answer: ReactNode;
};
type AccordionProps = {
  items: AccordionItem[];
  /** Index of the row expanded on first render. Pass -1 to start fully collapsed. */
  defaultOpenIndex?: number;
};
export function Accordion({
  items,
  defaultOpenIndex = 0
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);
  const baseId = useId();
  return <div className="divide-y divide-ink/10 border-y border-ink/10" data-id="element-81" data-mp="2i54ge6ott51x">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      const panelId = `${baseId}-panel-${index}`;
      const buttonId = `${baseId}-button-${index}`;
      return <div key={item.question} data-id="element-82" data-mp="2s17khi38ndri" data-mpi={index}>
            <h3 data-id="element-83" data-mp="11pukqd6lojb7">
              <button type="button" id={buttonId} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? -1 : index)} className="flex w-full min-h-[56px] items-center justify-between gap-4 py-4 text-left text-[17.5px] font-semibold leading-7 text-ink transition-colors duration-150 ease-out hover:text-pegasus-blue" data-id="element-84" data-mp="11re1e4w64wdi">
                {item.question}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-pegasus-blue transition-transform duration-150 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-85" data-mp="3uu1qblxvs2qy" />
              </button>
            </h3>
            <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!isOpen} className="pb-5 pr-2" data-id="element-86" data-mp="coevhyc0vy1y">
              <div className="max-w-3xl text-[16.5px] leading-6 text-ink/80" data-id="element-87" data-mp="2efs0endzq5y0">{item.answer}</div>
            </div>
          </div>;
    })}
    </div>;
}